import { render, staticRenderFns } from "./SBCategoryButton.html?vue&type=template&id=b52c3d5c&scoped=true&"
import script from "./SBCategoryButton.ts?vue&type=script&lang=ts&"
export * from "./SBCategoryButton.ts?vue&type=script&lang=ts&"
import style0 from "./SBCategoryButton.css?vue&type=style&index=0&id=b52c3d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52c3d5c",
  null
  
)

export default component.exports